import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Map, fromJS } from 'immutable';
import { MOVE_TEMPORARY_ITEM, TEMPORARY_ITEM_ID, TEMPORARY_QUIZ_ENTRY_ID, TEMPORARY_BANK_ENTRY_ID, TEMPORARY_BANK_ID, TEMPORARY_STIMULUS_ID, CLEAR_NEXT_QUIZ_ENTRY, CLEAR_TEMPORARY_ITEM, CLEAR_TEMPORARY_BANK_ITEM, CLEAR_TEMPORARY_STIMULUS, CREATE_TEMPORARY_ITEM, CREATE_TEMPORARY_BANK_ITEM, CREATE_TEMPORARY_BANK, CREATE_TEMPORARY_STIMULUS, QUIZ_MODIFICATION, BANK_MODIFICATION, QUIZ_ENTRIES_MODIFICATION, QUIZ_SESSION_RESULT_MODIFICATION, ITEM_MODIFICATION, STIMULUS_MODIFICATION, CLEAR_MODIFICATIONS, SET_NEXT_QUIZ_ENTRY, SESSION_ITEM_RESULTS_MODIFICATION } from '@instructure/quiz-common';
import { mergeDeepOnlyMaps } from '../util/immutableHelpers';
import Stimulus from '../records/Stimulus';
var defaultObjMods = function defaultObjMods(objId) {
  var keyAttr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  return Map(_defineProperty({}, keyAttr, objId));
};
var mergeMods = function mergeMods(initialMods, modificationsMap) {
  return initialMods.merge(fromJS(modificationsMap));
};
var mergeModsDeep = function mergeModsDeep(initialMods, modificationsMap) {
  return initialMods.mergeWith(mergeDeepOnlyMaps, fromJS(modificationsMap));
};
var updateObjectOfType = function updateObjectOfType(state, key, modifications, objType) {
  var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
    _ref$keyAttr = _ref.keyAttr,
    keyAttr = _ref$keyAttr === void 0 ? 'id' : _ref$keyAttr,
    _ref$mergeFunc = _ref.mergeFunc,
    mergeFunc = _ref$mergeFunc === void 0 ? mergeMods : _ref$mergeFunc;
  return state.updateIn([objType, key], defaultObjMods(key, keyAttr), function (obj) {
    return mergeFunc(obj, modifications);
  });
};
var clearObject = function clearObject(state, action) {
  return state.deleteIn([action.payload.objectType, action.payload.objectId].concat(action.payload.deepKeys));
};
var clearTemporaryEntry = function clearTemporaryEntry(state, action, type, id) {
  return state.setIn(['quizzes', action.payload.quizId, 'quizEntries'], []).deleteIn(['quizEntries', TEMPORARY_QUIZ_ENTRY_ID]).deleteIn([type, id]);
};
var clearTemporaryBankEntry = function clearTemporaryBankEntry(state, action, type, id) {
  return state.setIn(['banks', action.payload.bankId, 'bankEntries'], []).deleteIn(['bankEntries', TEMPORARY_BANK_ENTRY_ID]).deleteIn([type, id]);
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fromJS({
    banks: {},
    items: {},
    quizEntries: {},
    quizzes: {},
    sessionItemResults: {}
  });
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case BANK_MODIFICATION:
      return updateObjectOfType(state, action.payload.id, action.payload.modifications, 'banks');
    case QUIZ_MODIFICATION:
      return updateObjectOfType(state, action.payload.id, action.payload.modifications, 'quizzes');
    case ITEM_MODIFICATION:
      return updateObjectOfType(state, action.payload.id, action.payload.modifications, 'items');
    case QUIZ_ENTRIES_MODIFICATION:
      return updateObjectOfType(state, action.payload.id, action.payload.modifications, 'quizEntries', {
        mergeFunc: mergeModsDeep
      });
    case SET_NEXT_QUIZ_ENTRY:
      return state.set('nextQuizEntry', Map(action.payload));
    case QUIZ_SESSION_RESULT_MODIFICATION:
      return updateObjectOfType(state, action.payload.id, action.payload.modifications, 'quizSessionResults');
    case SESSION_ITEM_RESULTS_MODIFICATION:
      return updateObjectOfType(state, action.payload.id, action.payload.modifications, 'sessionItemResults', {
        keyAttr: 'id'
      });
    case CREATE_TEMPORARY_BANK:
      return updateObjectOfType(state, TEMPORARY_BANK_ID, _objectSpread({
        title: ''
      }, action.payload), 'banks');
    case STIMULUS_MODIFICATION:
      return updateObjectOfType(state, action.payload.stimulus.id, action.payload.stimulus, 'stimuli');
    case CREATE_TEMPORARY_STIMULUS:
      return function () {
        var stimulusQuizMods = {
          quizEntries: [TEMPORARY_QUIZ_ENTRY_ID]
        };
        var stateWithStimulusQuizMods = updateObjectOfType(state, action.payload.quizId, stimulusQuizMods, 'quizzes');
        var tempStimulus = new Stimulus(_objectSpread({
          id: TEMPORARY_STIMULUS_ID,
          passage: action.payload.isPassage
        }, action.payload.isPassage && {
          orientation: 'top'
        })).toJS();
        var stateWithStimulusMods = updateObjectOfType(stateWithStimulusQuizMods, TEMPORARY_STIMULUS_ID, tempStimulus, 'stimuli');
        var stimulusPosition = action.payload.position === 0 ? 0.9 : action.payload.position - 0.1;
        var stimulusQuizEntryMods = {
          position: stimulusPosition,
          entry: TEMPORARY_STIMULUS_ID,
          entryType: 'Stimulus'
        };
        return updateObjectOfType(stateWithStimulusMods, TEMPORARY_QUIZ_ENTRY_ID, stimulusQuizEntryMods, 'quizEntries');
      }();
    case CREATE_TEMPORARY_ITEM:
      return function () {
        var quizMods = {
          quizEntries: [TEMPORARY_QUIZ_ENTRY_ID]
        };
        var stateWithQuizMods = updateObjectOfType(state, action.payload.quizId, quizMods, 'quizzes');
        var position = action.payload.position === 0 ? 0.9 : action.payload.position - 0.1;
        var _action$payload = action.payload,
          pointsPossible = _action$payload.pointsPossible,
          interactionTypeData = _action$payload.interactionTypeData;
        var quizEntryMods = _objectSpread(_objectSpread({}, pointsPossible != null && {
          pointsPossible: pointsPossible
        }), {}, {
          position: position,
          entry: TEMPORARY_ITEM_ID,
          entryType: 'Item',
          stimulusQuizEntryId: action.payload.parentEntryId
        });
        var stateWithQuizEntryMods = updateObjectOfType(stateWithQuizMods, TEMPORARY_QUIZ_ENTRY_ID, quizEntryMods, 'quizEntries');
        var itemMods = {
          answerFeedback: interactionTypeData.answerFeedback,
          calculatorType: interactionTypeData.calculatorType,
          feedback: interactionTypeData.feedback,
          interactionData: interactionTypeData.interactionData,
          interactionType: interactionTypeData.id,
          itemBody: interactionTypeData.itemBody,
          outcomeAlignmentSetGuid: interactionTypeData.outcomeAlignmentSetGuid,
          properties: interactionTypeData.properties,
          scoringAlgorithm: interactionTypeData.scoringAlgorithm,
          scoringData: interactionTypeData.scoringData,
          title: interactionTypeData.title,
          stimulusId: action.payload.stimulusId
        };
        var stateWithAllMods = updateObjectOfType(stateWithQuizEntryMods, TEMPORARY_ITEM_ID, itemMods, 'items');
        return stateWithAllMods;
      }();
    case CREATE_TEMPORARY_BANK_ITEM:
      return function () {
        var bankMods = {
          bankEntries: [TEMPORARY_BANK_ENTRY_ID]
        };
        var stateWithBankMods = updateObjectOfType(state, action.payload.bankId, bankMods, 'banks');
        var tempId = action.payload.bankEntryType === 'Item' ? TEMPORARY_ITEM_ID : TEMPORARY_STIMULUS_ID;
        var bankEntryMods = {
          entry: tempId,
          entryType: action.payload.bankEntryType
        };
        var stateWithBankEntryMods = updateObjectOfType(stateWithBankMods, TEMPORARY_BANK_ENTRY_ID, bankEntryMods, 'bankEntries');
        var bankItemMods = action.payload.bankEntryType === 'Item' ? {
          interactionData: action.payload.interactionTypeData.interactionData,
          interactionType: action.payload.interactionTypeData.id,
          itemBody: action.payload.interactionTypeData.itemBody,
          properties: action.payload.interactionTypeData.properties,
          scoringData: action.payload.interactionTypeData.scoringData,
          title: null
        } : {
          title: ''
        };
        var collection = action.payload.bankEntryType === 'Item' ? 'items' : 'stimuli';
        var stateWithMods = updateObjectOfType(stateWithBankEntryMods, tempId, bankItemMods, collection);
        return stateWithMods;
      }();
    case CLEAR_NEXT_QUIZ_ENTRY:
      return state["delete"]('nextQuizEntry');
    case CLEAR_TEMPORARY_STIMULUS:
      return clearTemporaryEntry(state, action, 'stimuli', TEMPORARY_STIMULUS_ID);
    case CLEAR_TEMPORARY_ITEM:
      return clearTemporaryEntry(state, action, 'items', TEMPORARY_ITEM_ID);
    case CLEAR_TEMPORARY_BANK_ITEM:
      return clearTemporaryBankEntry(state, action, 'items', TEMPORARY_ITEM_ID);
    case CLEAR_MODIFICATIONS:
      return clearObject(state, action);
    case MOVE_TEMPORARY_ITEM:
      return function () {
        var oldPosition = state.getIn(['quizEntries', TEMPORARY_QUIZ_ENTRY_ID, 'position']);
        var newPosition;
        if (action.payload.direction) {
          newPosition = action.payload.direction === 'up' ? oldPosition - 1 : oldPosition + 1;
        } else {
          var offset = action.payload.movingDown ? 0.9 : -0.1;
          newPosition = action.payload.position + offset;
        }
        var qeMods = {
          position: newPosition,
          stimulusQuizEntryId: action.payload.stimulusQuizEntryId
        };
        return updateObjectOfType(state, TEMPORARY_QUIZ_ENTRY_ID, qeMods, 'quizEntries');
      }();
    default:
      return state;
  }
});